// extracted by mini-css-extract-plugin
module.exports = {"root":"TextLoader_root__MBmMW","react-loading-skeleton":"TextLoader_react-loading-skeleton__p3IG1"};